export default {
  required: 'Povinné pole',
  incompleteFieldList: 'Najprv vyplňte: {fields}',
  unboundIssueListHeader: 'Pred uložením opravte',
  discardHeader: 'Zahodiť neuložené zmeny?',
  discardMessage: 'Týmto sa odstránia všetky úpravy od posledného uloženia.',
};
